import { createSlice } from "@reduxjs/toolkit";

const initialClassRequestState = {
  modifiedDate: "",
  lastModified: "",
  requestStatus: "",
  project: "",
  projectCode: "",
  site: "",
  wave: "",
  classRequestId: "",
  noOfClasses: "",
  trainingSolution: "",
  classFillGoal: "",
  prodFillGoal: "",
  prodFillGoalBillable: "",
  prodFillGoalNonBillable: "",
  hiringBand: "",
  rosterLockDate: null,
  classApprovalDate: null,
  classApprovalComments: "",
  trainingClassification: "",
  productionClassification: "",
  gpmPoc: "",
  classType: "",
  og: "",
  siteCode: "",
  rosterProdStartDate: null,
  resetHandler: false,
  siteLocationName: "",
  opsName: null,
  opsApproverOracleId: null,
  opsApprovalDate: null,
  parentClientDetails: null,
};

const classRequestSlice = createSlice({
  name: "classRequest",
  initialState: initialClassRequestState,
  reducers: {
    updateLastModifiedDate(state, action) {
      state.modifiedDate = action.payload ? action.payload : "";
    },
    updateLastModified(state, action) {
      state.lastModified = action.payload ? action.payload : "";
    },
    updateRosterProdStartDate(state, action) {
      state.rosterProdStartDate = action.payload ? action.payload : "";
    },
    updateSiteLocationname(state, action) {
      state.siteLocationName = action.payload;
    },
    updateRequestStatus(state, action) {
      state.requestStatus = action.payload ? action.payload : "";
    },
    updateProject(state, action) {
      state.project = action.payload ? action.payload : "";
    },
    updateSiteLocation(state, action) {
      state.site = action.payload ? action.payload : "";
      state.siteCode = action.payload ? action.payload : "";
    },
    updateWave(state, action) {
      state.wave = action.payload ? action.payload.toString() : "";
    },
    updateClassRequestId(state, action) {
      state.classRequestId = action.payload ? action.payload : "";
    },
    updateNoOfClasses(state, action) {
      state.noOfClasses = action.payload ? action.payload : "";
    },
    updateClassType(state, action) {
      state.classType = action.payload ? action.payload : "";
    },
    updateTrainingSolution(state, action) {
      state.trainingSolution = action.payload ? action.payload : "";
    },
    updateTrainingClassification(state, action) {
      state.trainingClassification = action.payload ? action.payload : "";
    },
    updateProdClassification(state, action) {
      state.productionClassification = action.payload ? action.payload : "";
    },
    updateClassFillGoal(state, action) {
      state.classFillGoal = action.payload ? action.payload : "";
    },
    updateProdFillGoal(state, action) {
      state.prodFillGoal = action.payload ? action.payload : "";
    },
    updateProdFillGoalBillable(state, action) {
      state.prodFillGoalBillable = action.payload ? action.payload : "";
    },
    updateProdFillGoalNonBillable(state, action) {
      state.prodFillGoalNonBillable = action.payload ? action.payload : "";
    },
    updateHiringBand(state, action) {
      state.hiringBand = action.payload ? action.payload : "";
    },
    updateRosterLockDate(state, action) {
      state.rosterLockDate = action.payload;
    },
    updateAssignRosterLockDate(state, action) {
      state.updateAssignRosterLockDate = action.payload ? action.payload : "";
    },
    updateClassApprovalDate(state, action) {
      state.classApprovalDate = action.payload;
    },
    updateClassApprovalCmt(state, action) {
      state.classApprovalComments = action.payload ? action.payload : "";
    },
    updateGpmPoc(state, action) {
      state.gpmPoc = action.payload ? action.payload : "";
    },
    updateOg(state, action) {
      state.og = action.payload ? action.payload : "";
    },
    updateOpsApprovalOracleId(state, action) {
      state.opsApproverOracleId = action.payload ? action.payload : "";
    },
    updateOpsApprovalName(state, action) {
      state.opsName = action.payload ? action.payload : "";
    },
    updateOpsApprovalDate(state, action) {
      state.opsApprovalDate = action.payload;
    },
    updateParentClientDetails(state, action) {
      state.parentClientDetails = action.payload;
    },
    resetHandlerFunction(state, action) {
      state.resetHandler = action.payload;
    },
    resetClassReq: () => initialClassRequestState,
    addClassRequest(state, action) {
      state.lastModified = action.payload.modifiedBy;
      state.modifiedDate = action.payload.modifiedDate;
      state.requestStatus = action.payload.requestStatus;
      state.project = action.payload.project;
      state.site = action.payload.siteCode;
      state.siteCode = action.payload.siteCode;
      state.wave =
        action.payload.wave !== null && action.payload.wave !== undefined
          ? action.payload.wave
          : "";
      state.classRequestId = action.payload.classRequestId;
      state.noOfClasses =
        action.payload.numberOfClasses === null
          ? ""
          : action.payload.numberOfClasses;
      state.trainingSolution = action.payload.trainingProduction;
      state.trainingClassification = action.payload.trainingClassification;
      state.productionClassification = action.payload.productionClassification;
      state.classFillGoal =
        action.payload.classFillGoal === null
          ? ""
          : action.payload.classFillGoal;

      state.prodFillGoalBillable = action.payload.productionFillGoalBillable;
      state.prodFillGoalNonBillable =
        action.payload.productionFillGoalNonBillable;
      state.hiringBands = action.payload.hiringBands;
      state.rosterLockDate = action.payload.rosterLockDate;
      state.classApprovalDate = action.payload.classApprovalDate;
      state.gpmPoc =
        action.payload.gpmpoc === null ? "" : action.payload.gpmpoc;
      state.og = action.payload.onboardingSupportedById;
      state.classType = action.payload.classType;
      state.projectCode = action.payload.projectCode;
      state.siteLocationName = action.payload.siteLocation;
      state.classApprovalComments =
        action.payload.classApprovalComments !== null
          ? action.payload.classApprovalComments
          : "";
      state.opsApproverOracleId = action.payload.opsApproverOracleId;
      state.opsName = action.payload.opsName;
      state.opsApprovalDate = action.payload.opsApprovalDate;
    },
  },
});

export const classRequestActions = classRequestSlice.actions;

export default classRequestSlice.reducer;
